import { httpClient } from "../../../../services/httpClient";

export const fetchRecepcionistaDashboard = () => httpClient.get("/api/dashboard/recepcionista");

const recepcionistaDashboardService = {
  fetch: fetchRecepcionistaDashboard,
};

export default recepcionistaDashboardService;
